// src/actions/socialMediaActions.js
import axios from 'axios';
import { baseURL, SAVE_SOCIAL_MEDIA, RESET_SOCIAL_MEDIA,GET_ALL_SOCIAL_MEDIA } from './types';

// ✅ CREATE Social Media (POST)
export const createSocialMedia = (socialData) => (dispatch) => {
  const token = localStorage.getItem('token');

  return axios({
    method: 'post',
    url: `${baseURL}/api/appointmentDoctorSocialMedia/create`,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    data: socialData,
  })
    .then((response) => {
      const latest = response.data?.data?.[response.data.data.length - 1] || {};
      dispatch({
        type: SAVE_SOCIAL_MEDIA,
        payload: {
          id: latest.id,
          FacebookURL: latest.FacebookURL || '',
          TwitterURL: latest.TwitterURL || '',
          InstagramURL: latest.InstagramURL || '',
          PinterestURL: latest.PinterestURL || '',
          LinkedinURL: latest.LinkedinURL || '',
          YoutubeURL: latest.YoutubeURL || '',
        },
      });
    })
    .catch((error) => {
      console.error('Create SocialMedia Error:', error.response?.data || error.message);
    });
};

// ✅ READ Social Media by Hospital ID (POST)
export const getSocialMediaById = (hospitalID) => (dispatch) => {
  const token = localStorage.getItem('token');

  return axios({
    method: 'post',
    url: `${baseURL}/api/appointmentDoctorSocialMedia/getall`,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    data: { hospitalID },
  })
    .then((response) => {
      const latest = response.data?.data?.[response.data.data.length - 1] || {};
      dispatch({
        type: SAVE_SOCIAL_MEDIA,
        payload: {
          id: latest.id,
          FacebookURL: latest.FacebookURL || '',
          TwitterURL: latest.TwitterURL || '',
          InstagramURL: latest.InstagramURL || '',
          PinterestURL: latest.PinterestURL || '',
          LinkedinURL: latest.LinkedinURL || '',
          YoutubeURL: latest.YoutubeURL || '',
        },
      });
    })
    .catch((error) => {
      console.error('Get SocialMedia Error:', error.response?.data || error.message);
    });
};

// ✅ UPDATE Social Media (PATCH)
export const updateSocialMedia = (socialData) => (dispatch) => {
  const token = localStorage.getItem('token');

  return axios({
    method: 'patch',
    url: `${baseURL}/api/appointmentDoctorSocialMedia/update`,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    data: socialData,
  })
    .then((response) => {
      const updated = response.data?.data || {};
      dispatch({
        type: SAVE_SOCIAL_MEDIA,
        payload: {
          id: updated.id,
          FacebookURL: updated.FacebookURL || '',
          TwitterURL: updated.TwitterURL || '',
          InstagramURL: updated.InstagramURL || '',
          PinterestURL: updated.PinterestURL || '',
          LinkedinURL: updated.LinkedinURL || '',
          YoutubeURL: updated.YoutubeURL || '',
        },
      });
    })
    .catch((error) => {
      console.error("Update SocialMedia Error:", error.response?.data || error.message);
    });
};

export const getAllSocialMedia = () => (dispatch) => {
  const token = localStorage.getItem('token');

  return axios({
    method: 'post',
    url: `${baseURL}/api/appointmentDoctorSocialMedia/getall`,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    // Sending an empty object tells the backend to return all records
    data: {},
  })
    .then((response) => {
      // Dispatch an action with the entire array of social media objects
      dispatch({
        type: GET_ALL_SOCIAL_MEDIA,
        payload: response.data?.data || [], // The payload is the full array
      });
    })
    .catch((error) => {
      console.error('Get All Social Media Error:', error.response?.data || error.message);
    });
};
export const clearSocialMediaState = () => (dispatch) => {
  dispatch({ type: RESET_SOCIAL_MEDIA });
};